import styled from "styled-components";
import Styleguide, { Colors, theme } from "./../theme";
import { Title } from "src/components";

export const PageContainer = styled.div`
  padding: 0px 24px;
  margin: 0 auto;

  @media (min-width: ${Styleguide.breakpoints.tablet}) {
    max-width: 496px;
    padding: 0px 64px;
  }

  @media (min-width: ${Styleguide.breakpoints.desktop}) {
    width: 496px;
    padding: 0px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 319px;
  gap: 16px;

  @media (min-width: ${Styleguide.breakpoints.tablet}) {
    max-width: 380px;
  }
  @media (min-width: ${Styleguide.breakpoints.desktop}) {
    max-width: 496px;
    gap: 32px;
  }
`;

export const FlexContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media (min-width: ${Styleguide.breakpoints.desktop}) {
    justify-content: flex-start;
    flex-direction: row;
  }
`;

export const ErrorContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: ${Styleguide.breakpoints.desktop}) {
    align-items: start;
  }
`;

export const MessageDescription = styled.div`
  display: flex;
  flex-direction: column;
  font-family: ${Styleguide.fonts.body.name};
  align-items: center;
  text-align: center;
  font-size: ${Styleguide.fontSizes[16]};
  color: ${theme(Colors.gray[500], Colors.white)};

  @media (min-width: ${Styleguide.breakpoints.tablet}) {
    padding: 0 32px;
  }

  @media (min-width: ${Styleguide.breakpoints.desktop}) {
    padding: 0;
    align-items: start;
    text-align: left;
    font-size: ${Styleguide.fontSizes[18]};
  }
`;

export const Icon = styled.svg`
  width: 100px;
  height: 100px;
  min-width: 100px;
  min-height: 100px;
  color: ${theme(Colors.green[100], Colors.lightGreen[100])};
  padding: 0px;
`;

export const ErrorSvg = styled(Icon)`
  color: ${theme(Colors.red[100], Colors.lightRed[100])};
`;

export const AlertSvg = styled(Icon)`
  color: ${theme(Colors.orange[100], Colors.lightOrange[100])};
`;

export const ErrorId = styled.div`
  display: flex;
  font-family: ${Styleguide.fonts.body.name};
  font-size: ${Styleguide.fontSizes[14]};
  font-style: normal;
  font-weight: ${Styleguide.fontWeights.regular};
  color: ${theme(Colors.gray[400], Colors.white)};
  text-align: center;
  line-height: 150%;
  margin: 0;
  padding: 16px 0;

  @media screen and (min-width: 496px) {
    font-size: ${Styleguide.fontSizes[16]};
    text-align: left;
  }
`;

export const ContainerButton = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 319px;
  gap: 16px;

  @media (min-width: ${Styleguide.breakpoints.tablet}) {
    width: 380px;
  }

  @media (min-width: ${Styleguide.breakpoints.desktop}) {
    width: 496px;
  }
`;

export const ContainerDescription = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 32px;
  max-width: 312px;

  @media (min-width: ${Styleguide.breakpoints.tablet}) {
    max-width: 380px;
  }

  @media (min-width: ${Styleguide.breakpoints.desktop}) {
    max-width: 496px;
  }
`;

export const Description = styled.p`
  font-family: ${Styleguide.fonts.body.name};
  font-size: ${Styleguide.fontSizes[14]};
  color: ${theme(Colors.gray[400], Colors.gray[100])};
  margin: 0;

  @media (min-width: ${Styleguide.breakpoints.desktop}) {
    font-size: ${Styleguide.fontSizes[16]};
  }
`;

export const ContainerInfoButton = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (min-width: ${Styleguide.breakpoints.desktop}) {
    gap: 32px;
  }
`;

export const TextBold = styled.p`
  font-family: ${Styleguide.fonts.body.name};
  font-weight: ${Styleguide.fontWeights.bold};
  margin: 0px;

  @media (min-width: ${Styleguide.breakpoints.tablet}) {
    max-width: 380px;
  }

  @media (min-width: ${Styleguide.breakpoints.desktop}) {
    max-width: 496px;
  }
`;

export const TextLabel = styled.label`
  padding-bottom: 8px;
`;

export const FamilyTitle = styled(Title)`
  font-weight: ${Styleguide.fontWeights.minbold};
`;

export const Divider = styled.hr`
  border: 0.5px solid ${Colors.gray[300]};
  width: 100%;
  margin: 0;
`;
